<label class="switcher form-check form-check-custom form-check-solid form-switch form-control-sm">
  <input
    class="switcher__input form-check-input"
    type="checkbox"
    (change)="onToggle($event)"
    [checked]="checked"
    [disabled]="disabled"
    test-id="checkbox-switcher"
  />
  <ng-content></ng-content>
</label>
